import React from "react";
import useGuardianshipBondForm from "../../../features/bonds/guardianship/hooks/useGuardianshipBondForm";
import BondWizardPageShell from "./BondWizardPageShell";
import { bondWizardPageConfig } from "./bondWizardPageConfig";

const VermostGuardianshipBondRequestForm = () => {
  const form = useGuardianshipBondForm();
  return (
    <BondWizardPageShell
      config={bondWizardPageConfig.guardianship}
      form={form}
    />
  );
};

export default VermostGuardianshipBondRequestForm;
